import React from "react";
import "./Nav.css";
import SvgIcon from "react-icons-kit";
import { NavLink } from "react-router-dom";
import { ic_aspect_ratio } from "react-icons-kit/md/ic_aspect_ratio";
import { ic_business } from "react-icons-kit/md/ic_business";
import { ic_restaurant } from "react-icons-kit/md/ic_restaurant";
import { ic_book } from "react-icons-kit/md/ic_book";
import { ic_face } from "react-icons-kit/md/ic_face";
import { ic_gamepad } from "react-icons-kit/md/ic_gamepad";
import { discord } from "./Media/discord";

export class NavMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTop: true,
      scroll: 120,
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateScrollPosition = this.updateScrollPosition.bind(this);
  }

  componentDidMount() {
    this.setState({ width: window.innerWidth });
    this.setState({ height: window.innerHeight });

    window.addEventListener("scroll", this.updateScrollPosition);
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateScrollPosition);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
    if (window.innerWidth < 900) {
      window.removeEventListener("scroll", this.updateScrollPosition);
    } else {
      window.addEventListener("scroll", this.updateScrollPosition);
    }
  }


  updateScrollPosition() {
    if (window.scrollY < 120) {
      let scroll = 120 - window.scrollY;
      this.setState({ scroll: scroll });
    } else if (window.scrollY >= 120) {
      this.setState({ scroll: 0 });
    } else if (window.scrollY === 0) {
      this.setState({ scroll: 120 });
    } else {
      this.setState({ scroll: 120 });
    }
  }

  render() {
    let divStyle = {
      top: this.state.scroll
    };

    if (this.state.width < 900) {
      divStyle = {
        top: 70
      };
    }

    const discordurl = "/api/discord2/login";

    return (
      <div>
        {(this.state.height >= 800 || this.state.width < 901) && (
          <div
            className={this.state.width > 900 ? "BigNav" : "Nav"}
            style={divStyle}
          >
            <ul className="NavUl">
              <NavLink
                className="NavLink expand"
                exact
                to="/"
                activeClassName="activeLink"
              >
                <li className="NavLi">
                  <SvgIcon size={45} icon={ic_aspect_ratio} />
                  <p> Hjem </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/signup"
                activeClassName="activeLink"
              >
                <li className="NavLi ">
                  <SvgIcon size={45} icon={ic_face} />
                  <p> Påmelding </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/compo"
                activeClassName="activeLink"
              >
                <li className="NavLi">
                  <SvgIcon size={45} icon={ic_gamepad} />
                  <p> Konkurranser </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/food"
                activeClassName="activeLink"
              >
                <li className="NavLi">
                  <SvgIcon size={45} icon={ic_restaurant} />
                  <p> Mat </p>
                </li>
              </NavLink>

              {/*   <NavLink className="NavLink" to="/music" activeClassName="activeLink">
       <li className="NavLi">
        <SvgIcon size={50} icon={ spotify }/>
        <p> Musikk </p>
        </li>
        </NavLink>*/}

              <NavLink
                className="NavLink expand"
                to="/info"
                activeClassName="activeLink"
              >
                <li className="NavLi">
                  <SvgIcon size={45} icon={ic_book} />
                  <p> Regler og info </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/contact"
                activeClassName="activeLink"
              >
                <li className="NavLi">
                  <SvgIcon size={45} icon={ic_business} />
                  <p> Om oss </p>
                </li>
              </NavLink>

              <div className="seperator"> </div>

              <a
                href="https://discord.gg/ybPp3KUzqM"
                className="NavLink expand"
                target="blank"
              >
                <li className="NavLi">
                  <SvgIcon size={50} icon={discord} />
                  <p> Discord </p>
                </li>
              </a>
            </ul>

            {false && <a href={discordurl}>discord</a>}
          </div>
        )}

        {/*MENU FOR LOWER SCREENS, IE PHONES IN LANDSCAPE*/}
        {this.state.height < 800 && this.state.width > 900 && (
          <div
            className={this.state.width > 900 ? "BigNav" : "Nav"}
            style={divStyle}
          >
            <ul className="NavUl">
              <NavLink
                className="NavLink expand"
                exact
                to="/"
                activeClassName="activeLink"
              >
                <li className="NavLiShort">
                  <SvgIcon size={28} icon={ic_aspect_ratio} />
                  <p> Hjem </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/signup"
                activeClassName="activeLink"
              >
                <li className="NavLiShort">
                  <SvgIcon size={28} icon={ic_face} />
                  <p> Påmelding </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/compo"
                activeClassName="activeLink"
              >
                <li className="NavLiShort">
                  <SvgIcon size={28} icon={ic_gamepad} />
                  <p> Konkurranser </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/food"
                activeClassName="activeLink"
              >
                <li className="NavLiShort">
                  <SvgIcon size={28} icon={ic_restaurant} />
                  <p> Mat </p>
                </li>
              </NavLink>

              {/*   <NavLink className="NavLink" to="/music" activeClassName="activeLink">
<li className="NavLi">
<SvgIcon size={50} icon={ spotify }/>
<p> Musikk </p>
</li>
</NavLink>*/}

              <NavLink
                className="NavLink expand"
                to="/info"
                activeClassName="activeLink"
              >
                <li className="NavLiShort">
                  <SvgIcon size={28} icon={ic_book} />
                  <p> Regler og info </p>
                </li>
              </NavLink>

              <NavLink
                className="NavLink expand"
                to="/contact"
                activeClassName="activeLink"
              >
                <li className="NavLiShort">
                  <SvgIcon size={28} icon={ic_business} />
                  <p> Om oss </p>
                </li>
              </NavLink>

              <div className="seperator"> </div>

              <a
                href="https://discord.gg/EqN6mdv"
                className="NavLink expand"
                target="blank"
              >
                <li className="NavLiShort">
                  <SvgIcon size={28} icon={discord} />
                  <p> Discord </p>
                </li>
              </a>
            </ul>

            {false && <a href={discordurl}>discord</a>}
          </div>
        )}
      </div>
    );
  }
}
export default NavMenu;



// WEBPACK FOOTER //
// ./src/Components/Nav/Nav.js